import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

function readRequiredEnv(
  name: "VITE_SUPABASE_URL" | "VITE_SUPABASE_ANON_KEY",
  value: unknown,
): string {
  if (typeof value !== "string" || value.trim() === "") {
    throw new Error(
      `${name} ausente. Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no ambiente de build. O client não tem fallback.`,
    );
  }
  return value;
}

const supabaseUrl = readRequiredEnv(
  "VITE_SUPABASE_URL",
  import.meta.env.VITE_SUPABASE_URL,
);
const supabaseAnonKey = readRequiredEnv(
  "VITE_SUPABASE_ANON_KEY",
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
